import classNames from 'classnames';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Button from '../../Button';
import FileUploadDone from '../../icons/FileUploadDone';

import { useThemeFlag } from '../../../../base/ThemeProvider';

import styles from '../FileUploader.module.scss';

const cx = classNames.bind(styles);

const Done = ({ className }) => {
  const newButtonsEnabled = useThemeFlag('newButtons');

  const fileUploaderClasses = cx(
    styles['file-uploader'],
    styles['file-uploader--is-working'],
    className
  );

  return (
    <div className={fileUploaderClasses}>
      <div className={styles['file-uploader__content']}>
        <div>
          <FileUploadDone className={styles['file-uploader__icon']} />
        </div>
        <div className={styles['file-uploader__title']}>
          {trans('document-upload.done')}
        </div>
      </div>
      <div>
        <Button
          disabled
          className={styles['file-uploader__button']}
          color={newButtonsEnabled && 'secondary'}
        >
          {trans('document-upload.done')}
        </Button>
      </div>
    </div>
  );
};

Done.propTypes = {
  className: PropTypes.string.isRequired
};

export default Done;
